/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface AddressCreatedRequest
 */
export interface AddressCreatedRequest {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressCreatedRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressCreatedRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressCreatedRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressCreatedRequest
     */
    street1?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressCreatedRequest
     */
    street2?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressCreatedRequest
     */
    street3?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressCreatedRequest
     */
    streetNo?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressCreatedRequest
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressCreatedRequest
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressCreatedRequest
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressCreatedRequest
     */
    country?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddressCreatedRequest
     */
    isDefault?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddressCreatedRequest
     */
    isResidential?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddressCreatedRequest
     */
    addressType?: AddressCreatedRequestAddressTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AddressCreatedRequestAddressTypeEnum {
    Billing = 'Billing',
    Shipping = 'Shipping',
    Both = 'Both'
}

